"use client"
import { ActionCard, Badge, Box, Group, Image, Paper, Text, TbExternalLink, UnstyledButton } from "@forestsync/ui"

import { useTranslations } from "next-intl"
import { useRouter } from "next/navigation"
import { platformNavItems } from "@/lib/navigation"

const MARKETPLACE_URL = process.env.NEXT_PUBLIC_MARKETPLACE_URL ?? "https://carbonomex.com"

export default function Components() {
  const navT = useTranslations("navigation")
  const descT = useTranslations("descriptions")
  const commonT = useTranslations("common")
  const router = useRouter()

  const allItems = [
    ...platformNavItems.filter((item) => !item.disabled),
    ...platformNavItems.filter((item) => item.disabled),
  ]
  const fullWidthItems = allItems.filter((item) => item.fullWidth)
  const gridItems = allItems.filter((item) => !item.fullWidth)

  const renderCard = (item: (typeof allItems)[0]) => {
    const Icon = item.icon
    return (
      <ActionCard
        key={item.href}
        title={navT(item.id)}
        description={descT(item.id)}
        icon={Icon}
        variant={item.fullWidth ? "compact" : "vertical"}
        color={item.color}
        className={`hover:scale-105 transition-transform duration-200 h-full w-full ${
          item.disabled ? "opacity-75" : ""
        }`}
        disabled={item.disabled}
        onClick={!item.disabled ? () => router.push(item.href) : undefined}
      >
        {item.disabled && (
          <Badge
            size="lg"
            variant="gradient"
            gradient={{ from: "timber", to: "forest" }}
            c="var(--mantine-color-body)"
            className="absolute -top-4 z-10 shadow-lg"
          >
            {commonT("comingSoon")}
          </Badge>
        )}
      </ActionCard>
    )
  }

  return (
    <Box className="w-full max-w-5xl px-6 flex flex-col gap-4">
      {fullWidthItems.map(renderCard)}
      <Box className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {gridItems.map((item) => (
          <div key={item.href}>{renderCard(item)}</div>
        ))}
      </Box>

      {/* Carbonomex — full-width external marketplace card */}
      <UnstyledButton
        onClick={() => window.open(MARKETPLACE_URL, "_blank", "noopener,noreferrer")}
        className="w-full block origin-center transition-all duration-300 hover:scale-105"
      >
        <Paper
          withBorder
          radius={20}
          p={36}
          shadow="sm"
          bd="2px solid var(--mantine-color-orange-3)"
          bg="var(--mantine-color-orange-light)"
          className="w-full"
        >
          <Group gap="xl" align="center" wrap="nowrap">
            <Image src="/carbonomex-icon.svg" h={56} w={56} alt="Carbonomex" className="shrink-0" />
            <Box>
              <Group gap={6} align="center" mb={4}>
                <Text size="lg" c="orange" fw={600}>{navT("carbonomex")}</Text>
                <TbExternalLink size={16} color="var(--mantine-color-orange-5)" />
              </Group>
              <Text size="sm" c="dimmed">{descT("carbonomex")}</Text>
            </Box>
          </Group>
        </Paper>
      </UnstyledButton>
    </Box>
  )
}
